import * as React from 'react';
import * as ReactDOM from 'react-dom';

const createReactElement = (elementTag: string, instance: any) => {
    document.querySelectorAll(elementTag).forEach(domContainer => {
        const attributeNames = domContainer.getAttributeNames();
        const attributes = {};
        attributeNames.forEach(key => {
            const validKey = key.replace(/\-.{1}/, x => x.toUpperCase().replace('-', ''));
            attributes[validKey] = domContainer.getAttribute(key);
        });
        const element = React.createElement(instance, attributes);
        ReactDOM.render(element, domContainer);
    });
};

const ReactHelper = {
    createReactElement
};

export default ReactHelper;
